import React, { createContext, useContext, useState } from 'react'
import { Dialog } from '../'
import './Calendar.css'

const context = createContext({})
export const useCalendar = () => useContext(context)

export const CalendarProvider = ({ children }) => {
  const [open, setOpen] = useState(false)
  const openCalendar = () => setOpen(true)

  return (
    <context.Provider value={{ openCalendar }}>
      <Dialog open={open} onClose={() => setOpen(false)} closeColor="black">
        <div className="calendar">
          <div>
            <iframe src="https://meetings-eu1.hubspot.com/meetings/podandhive/shivoo-meeting-link-" />
          </div>
        </div>
      </Dialog>
      {children}
    </context.Provider>
  )
}